import NutritiousEatingAndYourBody from './NutritiousEatingAndYourBody';
import NutritiousFoodChoices from './NutritiousFoodChoices';
import UnderstandingFoodLabels from './UnderstandingFoodLabels';
import RisksofPoorFoodChoices from './RisksofPoorFoodChoices';
import MakingNutritiousFoodChoices from './MakingNutritiousFoodChoices';

export default {
  title: 'Learn',
  children: [
    NutritiousEatingAndYourBody,
    NutritiousFoodChoices,
    UnderstandingFoodLabels,
    RisksofPoorFoodChoices,
    MakingNutritiousFoodChoices
  ]
};




// WEBPACK FOOTER //
// ./src/data/learn/index.js